// extracted by mini-css-extract-plugin
module.exports = {"Menu":"VerticalMenu_Menu__bTT6q","MenuWrapper":"VerticalMenu_MenuWrapper__1ooHS"};